import { useState } from "react";

import TableSize from "../../components/common/TableSize";
import Modal from "../../components/common/Modal";

import CorsHeader from "./components/CorsHeader";
import CorsTable from "./components/CorsTable";
import CorsFilter from "./components/CorsFilter";

const Cors = () => {
  const [data, setData] = useState([]);
  const [showFilter, setShowFilter] = useState(false);

  const [tableOptions, setTableOptions] = useState({
    status: "Active",
    rdo: "",
    cor: "",
    show: "",
    start_date: "",
    end_date: "",
    search_query: "",
    current_page: 1,
    page_size: 10,
    sort_column: { path: "date_generated", order: "desc" },
  });

  const columns = [
    { path: "name", label: "Name" },
    { path: "ocn", label: "OCN" },
    { path: "is_main_branch", label: "Type" },
    { path: "income_tax", label: "IT" },
    { path: "percentage_tax", label: "PT" },
    { path: "expanded_withholding_tax", label: "WT" },
  ];

  const { page_size: size } = tableOptions;

  const settings = [
    {
      id: 1,
      content: <TableSize size={size} onChange={(e) => handleSizeChange(e)} />,
    },
  ];

  const handleOptionsChange = (options) => setTableOptions(options);

  const handleSizeChange = (event) => {
    const page_size = event.target.value;

    if (page_size !== tableOptions.page_size) {
      const options = { ...tableOptions };
      options.page_size = page_size;
      options.current_page = 1;
      setTableOptions(options);
    }
  };

  const handleSearch = (query) => {
    const options = { ...tableOptions };

    if (options.search_query !== query) {
      options.status = "";
      options.rdo = "";
      options.cor = "";
      options.show = "";
      options.start_date = "";
      options.end_date = "";
      options.search_query = query;
      options.current_page = 1;
      handleOptionsChange(options);
    }
  };

  const handleFilter = (status, rdo, cor, show, start_date, end_date) => {
    const options = { ...tableOptions };
    options.status = status;
    options.rdo = rdo;
    options.cor = cor;
    options.show = show;
    options.start_date = start_date;
    options.end_date = end_date;
    handleOptionsChange(options);
    setShowFilter(false);
  };

  return (
    <div className="px-6 lg:px-0">
      <div className="card p-8 mt-5">
        <CorsHeader
          settings={settings}
          options={tableOptions}
          onSearch={handleSearch}
          setFilter={setShowFilter}
          onChange={handleOptionsChange}
        />
        <CorsTable
          data={data}
          columns={columns}
          tableOptions={tableOptions}
          setData={setData}
          onChange={handleOptionsChange}
        />
      </div>
      <Modal
        title="Filter"
        isOpen={showFilter}
        onClose={() => setShowFilter(false)}
        borderTop
      >
        <CorsFilter tableOptions={tableOptions} onFilter={handleFilter} />
      </Modal>
    </div>
  );
};

export default Cors;
